<template>
    <div  v-if="isBuilt" class="mt-5">
        <div v-if="reloading" class="spinner element-spinner d-flex flex-column justify-content-center align-items-center">
            <span class="spinner-border spinner-border-sm margin-right5" role="status" aria-hidden="true"></span>
        </div>
        <h1 v-if="!!kpiData.name" class="section-name col-12 mb-4 text-uppercase">{{kpiData.name}}</h1>
        <div v-if="showQueries" v-html="this.query">{{ this.query }}</div>
        <template v-if="!!missed_accounts.length">
            <div v-for="missed_account in missed_accounts" class="missed-accounts mb-3">There are no accounts connected for {{missed_account}}. Either connect an account or change the metrics/remove this section in the builder.</div>
        </template>
        <div v-if="errors" class="empty-data"><img :src="$store.state.app_url+'/images/errors.gif'"></div>
        <div v-else class="row justify-content-center kpi-top" :class="!!kpiData.name ? 'mt-3' : 'mt-5'">
            <div v-for="(box, idx) in orderedBoxes" class="col-12 d-flex flex-column justify-content-center my-1" :class="['col-sm-'+box.colInfos['sm'], 'col-md-'+box.colInfos['md'], 'col-lg-'+box.colInfos['lg'], 'col-xl-'+box.colInfos['xl']]">
                <div class="kpi-wrap pt-3 d-flex flex-column justify-content-between flex-grow-1" :class="{'left':box.index % 2 == 0, 'right':box.index % 2 > 0}">
                    <h3 class="kpi-title text-center text-uppercase mb-0 pb-0">{{box.metric_name}}</h3>
                    <blockquote class="text-center">
                        <p class="card-value" :class="{'compare':show_compare, 'arrows':show_arrows}">{{box.final_value1}}<span v-if="show_compare" class="compare"> ({{box.final_value2}})</span><span v-if="show_arrows" class="amount" :class="box.cls">{{box.amount}}</span></p>
                    </blockquote>
                    <template v-if="show_index_values">
                        <h5 class="text-center">vs {{index_name}}</h5>
                        <blockquote class="text-center">
                            <p class="card-value" :class="{'compare':show_compare, 'arrows':show_arrows}">{{orderedIndexBoxes[idx].final_value1}}<span v-if="show_compare" class="compare"> ({{orderedIndexBoxes[idx].final_value2}})</span><span v-if="show_arrows" class="amount" :class="orderedIndexBoxes[idx].cls">{{orderedIndexBoxes[idx].amount}}</span></p>
                        </blockquote>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: ['isBuilt', 'hasSkb', 'kpiData'],
        created(){
            this.show_arrows = this.kpiData.element_configurations.show_arrows;
            this.show_compare = this.kpiData.element_configurations.show_comparison;
            this.show_index_values = this.kpiData.element_configurations.show_index_values;
            this.index_name = this.kpiData.element_configurations.select_index_name;
            this.filter_element = this.kpiData.element_configurations.filter_element;
            this.num_metrics = this.kpiData.metrics.length;
            this.numBoxes = this.num_metrics;
            this.numRows = Math.ceil(this.numBoxes / this.maxBoxesInARow);
            this.rowNumbers = this.getRowNumbers();
            _.each(this.kpiData.metrics, (boxData, index) => {
                let colInfos = this.getColumnInfos(index, this.rowNumbers);
                let boxNum = colInfos['boxNum'];
                let box = {
                    'index': index,
                    'colInfos': colInfos,
                    'boxNum': boxNum,
                    'prefix': boxData['prefix'],
                    'suffix': boxData['suffix'],
                    'dp': boxData['metric_dp'],
                    'metric_name': boxData['metric_name'],
                    'final_value1': 0,
                    'final_value2': 0,
                    'final_full_value1': 0,
                    'final_full_value2': 0,
                    'cls': 'inv',
                    'amount': ''
                };
                let metric_key = boxData.metric_id + '_' + boxData.data_source_id;
                Vue.set(this.boxes, metric_key, box);
            });
            if(this.show_index_values){
                this.index_boxes = _.merge({}, this.boxes);
            }
            this.fetchServerData();
            this.missed_accounts = this.checkAccounts(this.kpiData);
        },
        mounted(){
            event_bus.$on('reloading', () => {
                this.reloading = true;
                this.fetchServerData();
            });
        },
        data() {
            return {
                isArchive:this.$store.state.isArchive,
                show_arrows:false,
                show_compare:false,
                show_index_values:false,
                index_name:null,
                boxes:{},
                index_boxes:{},
                num_metrics:0,
                numBoxes:0,
                maxBoxesInARow: 2,
                numRows:        0,
                rowNumbers:     0,
                filter_element: null,
                missed_accounts:[],
                errors:false,
                query:'',
                showQueries:    this.$store.state.showQueries,
                reloading:true
            }
        },
        computed: {
            orderedBoxes: function () {
                return _.orderBy(this.boxes, 'index')
            },
            orderedIndexBoxes: function () {
                return _.orderBy(this.index_boxes, 'index')
            }
        },
        methods: {
            fetchServerData(){
                const params = {
                    'isArchive':this.isArchive,
                    'prefixed_id': this.isArchive ? this.kpiData.archive_id : this.kpiData.report_id,
                    'element_abbr':this.kpiData.element_abbreviation,
                    'dwm':this.$store.state.current_dwm,
                    'dates':this.$store.state.current_dates,
                    'element_id': this.kpiData.element_id,
                    'client_id':this.kpiData.client_id,
                    'client_name':this.kpiData.client_name,
                    'prefixed_element_id': this.kpiData.report_element_id,
                    'element_name': this.kpiData.name,
                    'metrics': this.kpiData.metrics,
                    'accounts': this.kpiData.accounts,
                    'show_arrows':this.show_arrows,
                    'show_compare':this.show_compare,
                    'show_index_values': this.show_index_values,
                    'index_name':this.index_name,
                    'filter_element':this.filter_element,
                    'showQueries':this.showQueries,
                    'hasSkb':this.hasSkb,
                };

                axios.post('/api/reporting/element', params).then((response) => {
                    if(!!response.data && (typeof(response.data) == 'object')){
                        this.query = response.data.query;
                        this.errors = response.data.errors;
                        let boxes_data = response.data.boxes_data;
                        let index_boxes_data = response.data.index_boxes_data;
                        _.each(boxes_data, (boxData, key) => {
                            if(this.boxes.hasOwnProperty(key)){
                                this.boxes[key]['final_value1'] = boxData['final_value1'];
                                this.boxes[key]['final_value2'] = boxData['final_value2'];
                                this.boxes[key]['final_full_value1'] = boxData['final_full_value1'];
                                this.boxes[key]['final_full_value2'] = boxData['final_full_value2'];
                                this.boxes[key]['amount'] = boxData['amount'];
                                this.boxes[key]['cls'] = boxData['cls'];
                                this.boxes[key]['metric_name'] = boxData['metric_name'];
                            }
                        });

                        if(this.show_index_values){
                            _.each(index_boxes_data, (indexBoxData, idx) => {
                                if(this.index_boxes.hasOwnProperty(idx)){
                                    this.index_boxes[idx]['final_value1'] = indexBoxData['final_value1'];
                                    this.index_boxes[idx]['final_value2'] = indexBoxData['final_value2'];
                                    this.index_boxes[idx]['final_full_value1'] = indexBoxData['final_full_value1'];
                                    this.index_boxes[idx]['final_full_value2'] = indexBoxData['final_full_value2'];
                                    this.index_boxes[idx]['amount'] = indexBoxData['amount'];
                                    this.index_boxes[idx]['cls'] = indexBoxData['cls'];
                                    this.index_boxes[idx]['metric_name'] = indexBoxData['metric_name'];
                                }
                            });
                        }
                    }
                    this.reloading = false;
                });
            },
            getRowNumbers(){
                if (this.numRows == 1) return [this.numBoxes];

                let ret = [];
                let numRows = this.numRows;
                let rest = this.numBoxes;

                for (var j = 0; j < numRows; j++) {
                    let num = Math.ceil(rest / (numRows - j));
                    rest -= num;
                    ret.push(num);
                }

                return ret;
            },
            getColumnInfos(idx, rowNumbers){
                let idx_mod = idx < this.maxBoxesInARow ? idx : idx % this.maxBoxesInARow;
                let partial = 0;
                let boxNum = 0;
                let ret = {};
                if (rowNumbers.length > 0) {
                    _.each(rowNumbers, (num, index) => {
                        partial += parseInt(num);
                        if (idx < partial) {
                            boxNum = num;
                            return false;
                        }
                    });
                    switch (boxNum) {
                        case 1:
                            ret = {'sm':12, 'md': 12, 'lg': 12, 'xl':12};
                            break;
                        case 2:
                            if(!this.show_arrows && !this.show_compare){
                                ret = {'sm':6, 'md': 6, 'lg': 6, 'xl':6};
                            }
                            else if(this.show_arrows ? !this.show_compare : this.show_compare){
                                ret = {'sm':12, 'md': 6, 'lg': 6, 'xl':6};
                            }
                            else{
                                ret = {'sm':12, 'md': 6, 'lg': 6, 'xl':6};
                            }

                            break;
                        case 3:
                            ret = {'sm':12, 'md': (idx_mod < 2) ? 6 : 12, 'lg': (idx_mod < 2) ? 6 : 12, 'xl':(idx_mod < 2) ? 6 : 12};
                            break;
                        case 4:
                            if(!this.show_arrows && !this.show_compare){
                                ret = {'sm':6, 'md': 6, 'lg': 6, 'xl':6};
                            }
                            else if(this.show_arrows ? !this.show_compare : this.show_compare){
                                ret = {'sm':12, 'md': 6, 'lg': 6, 'xl':6};
                            }
                            else{
                                ret = {'sm':12, 'md': 12, 'lg': 6, 'xl':6};
                            }
                            break;
                        default:
                            //we should never be here
                            ret = {'sm':0, 'md': 0, 'lg': 0};
                    }

                    ret['boxNum'] = boxNum;

                    return ret;
                }
                //we should never be here
                return {'boxNum':0, 'xs':0, 'sm':0, 'md':0, 'lg':0};
            },
        }
    }
</script>

<style lang="scss">
    @import '~@/_variables.scss';
    @import "~bootstrap/scss/functions";
    @import "~bootstrap/scss/variables";
    @import "~bootstrap/scss/mixins";
    div.kpi-top{
        div.kpi-wrap{
            border-radius:2rem;
            color:white;
            letter-spacing: 0.4rem;

            &.left{
                background-color:$black-blue;
            }
            &.right{
                background-color:$light-blue;
            }
            blockquote{
                margin-bottom:0;
                p.card-value{
                    position:relative;
                    display:inline-block;
                    font-family:'Chronicle Display Extra Light';
                    font-size:6rem;
                    &.compare{
                        font-size:2rem;
                    }
                    margin-bottom:0;
                    @include media-breakpoint-up(sm) {
                        font-size:6rem;
                        &.compare{
                            font-size:5rem;
                        }
                    }
                    @include media-breakpoint-up(xl) {
                        font-size:8rem;
                        line-height:10rem;
                        &.compare{
                            font-size:8rem;
                        }
                    }
                    span.compare{
                        font-size:2rem;
                        @include media-breakpoint-up(lg) {
                            font-size:3rem;
                        }
                    }
                    span.amount {
                        position: relative;
                        display:inline-block;
                        font-size:2rem;
                        text-align: left;
                        vertical-align: middle;
                        margin-left:3rem;
                        &::before {
                            border-left: 1.5rem solid transparent;
                            border-right: 1.5rem solid transparent;
                            content: "";
                            display: inline-block;
                            height: 0;
                            width: 0;
                            margin-right:1rem;
                        }
                        &.up{
                            &::before {
                                border-bottom: 1.2rem dashed white;
                            }
                        }
                        &.down{
                            &::before {
                                border-top: 1.2rem dashed white;
                            }
                        }
                        &.inv{
                            width:2rem;
                            height:2rem;
                            background-color:white;
                        }
                    }
                }
            }
        }
    }
</style>

